import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PasteImageDirective } from './paste-image.directive';
import { RangeSelectDirective, RangeSelectItemDirective } from './range-select.directive';
import { PasteImageZoneComponent } from './paste-image-zone.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTooltipModule
    ],
    declarations: [
        PasteImageDirective,
        PasteImageZoneComponent,
        RangeSelectDirective,
        RangeSelectItemDirective
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PasteImageDirective,
        PasteImageZoneComponent,
        RangeSelectDirective,
        RangeSelectItemDirective
    ]
})
export class SharedModule {
}
